import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setBreadCrumbs } from '../actions/breadcrumbs.js';
import { setActiveProposal } from '../actions/application.js';
import { selectDataCollection, unselectDataCollection ,processDataCollectionGroup, selectDataCollectionGroup, unselectDataCollectionGroup } from '../actions/application.js';
import { fetchSessionsByProposal } from '../actions/sessions.js';
import DataCollectionListDataCollectionGroupPanel from '../components/Mx/DataCollectionGroup/DataCollectionListDataCollectionGroup/DataCollectionListDataCollectionGroupPanel.js';
import DataCollectionsAnalysisToolContainer from '../containers/DataCollectionsAnalysisToolContainer.js';

class SelectionContainer extends Component {

  render() {              
    if ((!this.props.user) || (!this.props.user.token)) {         
      return null;
    }

    if (!this.props.application.selectedDataCollections){
      return "No selection";
    }
    if (this.props.application.selectedDataCollections.length == 0){
      return "No selection";
    }
    
    return <div>
                      <DataCollectionsAnalysisToolContainer datacollections={this.props.application.selectedDataCollections} jobs={this.props.jobs} configuration={this.props.configuration}></DataCollectionsAnalysisToolContainer>                                        
                      <br />
                      <DataCollectionListDataCollectionGroupPanel 
                      fetching={false} 
                      dataCollections={this.props.application.selectedDataCollections}    
                      processDataCollection={this.props.processDataCollection} 
                      selectDataCollection={this.props.selectDataCollection}
                      unselectDataCollection={this.props.unselectDataCollection}
                      proposal={this.props.application.activeProposal.name}                  
                      user={this.props.user.token}    
                      selectedDataCollections={this.props.application.selectedDataCollections}                    
                      >                        
                      </DataCollectionListDataCollectionGroupPanel>
            </div>;

    /*
      FOR DATA COLLECTION GROUPS
      (
        <div style={{marginBottom : '100px'}}>     
          {this.props.application.selectedDataCollectionGroups.map((value, index) => {                         
            return <div style={{marginBottom:'20px'}} key={index}>
                    <LazyLoad height={200} offset={100} once>
                      <DataCollectionGroupPanel 
                                  selectDataCollectionGroup={this.props.selectDataCollectionGroup}
                                  unselectDataCollectionGroup={this.props.unselectDataCollectionGroup}
                                  selectDataCollection={this.props.selectDataCollection}
                                  unselectDataCollection={this.props.unselectDataCollection}
                                  processDataCollectionGroup={this.props.processDataCollectionGroup}
                                  application={this.props.application}
                                  proposal={this.props.proposal}
                                  sessionId={this.props.sessionId}  
                                  token={this.props.user.token} 
                                  datacollectiongroup={value}
                                  configuration={this.props.configuration}
                                 
                                  >
                      </DataCollectionGroupPanel>
                </LazyLoad>
            </div>
        })}                                  
    </div>);  */
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    proposals : state.proposals,
    application : state.application,
    configuration : state.configuration
        
  };
}

function mapDispatchToProps(dispatch) {
  return {  
    setBreadCrumbs: (breadCrumbs) => dispatch(setBreadCrumbs(breadCrumbs)),
    setActiveProposal: (proposal, title) => dispatch(setActiveProposal(proposal, title)),
    fetchSessionsByProposal: (token, proposal) => dispatch(fetchSessionsByProposal(token, proposal)),   
    selectDataCollectionGroup: (dataCollection) => dispatch(selectDataCollectionGroup(dataCollection)),
    unselectDataCollectionGroup: (dataCollection) => dispatch(unselectDataCollectionGroup(dataCollection)),
    selectDataCollection: (dataCollection) => dispatch(selectDataCollection(dataCollection)),
    unselectDataCollection: (dataCollection) => dispatch(unselectDataCollection(dataCollection)),
    processDataCollectionGroup: (dataCollection) => dispatch(processDataCollectionGroup(dataCollection))
         
  };
}



export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectionContainer);










// WEBPACK FOOTER //
// ./src/containers/SelectionContainer.js